import { ibkApi } from '@ibk/shared-config';
import { parsePdfResponse } from './pdfResponseParser';
export const buildDownloadOrderTaxInvoicePdfMutation = ({ contractId, orderId, taxInvoiceId, }) => ({
    url: `/v1/benefits/contracts/${contractId}/orders/${orderId}/invoice/${encodeURIComponent(taxInvoiceId)}/pdf`,
    method: 'GET',
    responseHandler: parsePdfResponse,
});
export const contractOrderTaxInvoiceApi = ibkApi.injectEndpoints({
    endpoints: build => ({
        downloadEmissorOrderTaxInvoicePdf: build.mutation({
            query: buildDownloadOrderTaxInvoicePdfMutation,
        }),
    }),
    overrideExisting: false,
});
export const { useDownloadEmissorOrderTaxInvoicePdfMutation } = contractOrderTaxInvoiceApi;
